import { EdmLiteral } from 'devextreme/data/odata/utils';

/**
 * Fixes OData / datetime(offset) filtering issues
 * @param filters The load options for the component
 *
 * @example
    new ODataStore({
        version: 4,
        onLoading: options => {
            fixOdataDateOffsetFilter(options.filter);
        },
    }),
 */

export function fixOdataDateOffsetFilter(filters: any[]) {
	if (filters == null || filters.length === 0) return;

	const yyyyMMddRegex = /^\d{4}-\d{2}-\d{2}$/;

	// https://regex101.com/r/v9XzDy/1
	const isDate = obj => {
		return /(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d\.\d+)|(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d)|(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d)/.test(
			obj
		);
	};

	// Helper method to loop through the filters
	const fixFilterValue = filter => {
		// don't need to handle the operators
		if (filter === 'and' || filter === 'or') {
			return;
		} else if (Array.isArray(filter[0])) {
			// Nested filter option
			filter.forEach(nestedFilter => fixFilterValue(nestedFilter));
		} else {
			// Handle dates
			if (filter[2] instanceof Date) {
				filter[2] = new EdmLiteral(filter[2].toISOString());
			} else if (isDate(filter[2])) {
				filter[2] = new EdmLiteral(filter[2]);
			} else if (yyyyMMddRegex.test(filter[2])) {
				filter[2] = new EdmLiteral(filter[2]);
			}
		}
	};

	// If filters has only one filter
	if (Array.isArray(filters) && filters.length === 3 && typeof filters[0] === 'string') {
		// Fix for the only filter
		fixFilterValue(filters);
	} else {
		// Loop through the filters and fix the dates
		Object.values(filters).forEach(filter => {
			fixFilterValue(filter);
		});
	}
}
